// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"182": "gsap-vendor","460": "quickjs-sandbox","498": "geo-vendor",}[chunkId] || chunkId) + "." + {"182": "69ca1ee6e3fb9b40","396": "58b3f9fbfa91b822","460": "9b015cc71d9553b5","498": "1bd4a9dc499d8a73","917": "cab10ac510fbdf57","985": "a27da891271fa6d1",}[chunkId] + ".chunk.js"
}